import type { BlockchainDocument, BlockchainVerificationResult } from '@/types/blockchainDocuments';

export const isBlockchainDocumentStorageEnabled = () => process.env.REACT_APP_BLOCKCHAIN_DOCUMENT_STORAGE_ENABLED === 'true';

export const resolveBlockchainNavigationLinks = <T extends { url?: string; children?: T[] }>(links: T[]): T[] =>
  links
    .filter((link) => link.url !== '/blockchainDocuments' || isBlockchainDocumentStorageEnabled())
    .map((link) => ({
      ...link,
      children: link.children ? resolveBlockchainNavigationLinks(link.children) : link.children,
    }));

export const createBlockchainIdempotencyKey = () => {
  if (typeof globalThis.crypto?.randomUUID === 'function') return globalThis.crypto.randomUUID();
  if (typeof globalThis.crypto?.getRandomValues === 'function') {
    const bytes = new Uint8Array(24);
    globalThis.crypto.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  }
  return `blockchain-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
};

export const blockchainUploadMessageKey = (document: BlockchainDocument, reused: boolean) => {
  if (reused) return 'reused';
  return (document.anchor_status || document.status) === 'queued' ? 'queued' : 'storedLocally';
};

export const blockchainVerificationMessageKey = (result: BlockchainVerificationResult) => {
  if (!result.matches) return 'mismatch';
  return result.anchor_confirmed ? 'matchAnchored' : 'matchLocal';
};
